import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Lenis from "lenis";

let lenis = null;

export function SmoothScroll() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let id = 0;
    const raf = (t) => { lenis?.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis?.destroy(); lenis = null; };
  }, []);
  useEffect(() => {
    const t = setTimeout(() => {
      const el = hash ? document.querySelector(hash) : null;
      if (el) {
        if (lenis) lenis.scrollTo(el, { offset: -96 });
        else el.scrollIntoView();
      } else if (lenis) lenis.scrollTo(0, { immediate: true });
      else window.scrollTo(0, 0);
    }, hash ? 250 : 0);
    return () => clearTimeout(t);
  }, [pathname, hash]);
  return null;
}
